import { LANGUAGE, TRANSLATIONS, translate } from "./locales/index.js";

const BIRTHYEAR_KEY = "sociodemo_birthyear";
const BIRTHYEAR_MAX_LENGTH = 4;
const OPINION_KEY = "opinion";
const COMMENT_KEY = "comment";
const CLOSED_QUESTION_PAGE_KEY = "closed-question";

export function alterSurveySettings(settings) {
  const questions = questionsOf(settings);

  showClosedQuestionHeaderTitle(settings.pages);
  limitBirthyearToFourDigits(questions);
  titleClosedQuestion(questions);
  titleOpenQuestionByOpinion(questions);

  return settings;
}

function showClosedQuestionHeaderTitle(pages) {
  const closedQuestion = pages.find(
    (page) => page.key === CLOSED_QUESTION_PAGE_KEY,
  );
  if (!closedQuestion) return;

  closedQuestion.srOnlyHeaderTitle = false;
}

function limitBirthyearToFourDigits(questions) {
  const birthyear = questions.find(
    (question) => question.key === BIRTHYEAR_KEY,
  );
  if (!birthyear) return;

  birthyear.maxLength = BIRTHYEAR_MAX_LENGTH;
}

function titleClosedQuestion(questions) {
  const opinion = questions.find((question) => question.key === OPINION_KEY);
  if (!opinion) return;

  opinion.title = { [LANGUAGE]: translate("embed.closedQuestion.label") };
}

function titleOpenQuestionByOpinion(questions) {
  const comment = questions.find((question) => question.key === COMMENT_KEY);
  if (!comment) return;

  const titles = TRANSLATIONS.embed.openQuestion.label;
  const ownTitle = comment.title?.[LANGUAGE];
  comment.title = {
    [LANGUAGE]: (store) => titles[store.getAnswer(OPINION_KEY)] ?? ownTitle,
  };
}

function questionsOf(settings) {
  return settings.pages.flatMap((page) =>
    page.sections.flatMap((group) => group.sections ?? []),
  );
}
